import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { mediumScreens } from 'components/common/fontElements';

export const Container = styled.dl`
  display: flex;
  margin-bottom: 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  line-height: 16px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  > div {
    &:first-of-type {
      padding-right: 12px;
    }

    > dt {
      display: inline-block;
      font-weight: 400;
      color: ${colors.darkGray1};

      &:after {
        content: ': ';
        padding-right: 5px;
      }
    }

    > dd {
      display: inline-block;
      color: ${({ theme }) => (theme === 'light' ? colors.darkGray1 : colors.lightBlack)};
      font-weight: 500;
    }
  }
`;

export const Timestamp = styled.div`
  > span {
    &:first-child {
      padding-right: 4px;
    }
  }
`;
